'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationVpnKey = function CommunicationVpnKey(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
CommunicationVpnKey = (0, _pure2.default)(CommunicationVpnKey);
CommunicationVpnKey.displayName = 'CommunicationVpnKey';
CommunicationVpnKey.muiName = 'SvgIcon';

exports.default = CommunicationVpnKey;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/communication/vpn-key.js
// module id = 1313
// module chunks = 0